import {Component} from '@angular/core';
import {WizardPageBaseComponent} from '@utils-lib';
import {LohnsteuerAngaben} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'common-ui-lohnsteuer-angaben',
  templateUrl: './lohnsteuer-angaben.component.html'
})
export class LohnsteuerAngabenComponent extends WizardPageBaseComponent<LohnsteuerAngaben> {

  static nutzdatenPath = 'lohnsteuerAngaben';
  static route = 'lohnsteuer-angaben';

  constructor(protected readonly activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
    return new Map<string, unknown | Array<unknown>>([]);
  }
}
